import React, { Component } from 'react'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBBtn, MDBContainer, MDBCardFooter } from "mdbreact";
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class PowerWeek extends Component {
  render() {
    return (
        	<div class="container white_background">
		<div class="row justify-content-center Concepts_intro no-gutters">
			<div class="col-0 col-sm-0 col-md-0 col-lg-4 col-xl-4 Concepts_intro_title_B ">
			    <p class="Concepts_line2">POWER<br />Weeks</p>
			</div>
			<div class="col Concepts_intro_content justify-content-center">
				<div class="row Concepts_intro_brief justify-content-center no-gutters">
					<p>During your 5 Power Weeks, we ask that you enter all of your meals, snacks, drinks, and sleep times into the app for <font style={{color:"#3c5b89"}}> 7 full days, from Monday to Sunday.</font> </p>
				</div>
				<div class="row power_week_calendar">
					<div class="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11">
						<img class="power_week_calendar_img" src="https://i.ibb.co/8zcMKG8/slice65-3x.png" alt="slice65-3x" border="0"/>
					</div>
					<div class="col"></div>
					<div class="col-11 col-sm-11 col-md-11 col-lg-6 col-xl-6">
						<img class="power_week_calendar_img_2" src="https://i.ibb.co/dsN7pvy/slice51-3x.png" alt="slice51-3x" border="0"/>


					</div>
					<div class="col-10 col-sm-10 col-md-6 col-lg-6 col-xl-6 power_week_calendar_notes">
						<p class="calendar_notes_h"><img src="https://i.ibb.co/Y3t2Pvg/slice50-3x.png" alt="slice50-3x" border="0" class="list_style_tri"/> Start on</p>
					    <p class="calendar_notes_p">the Monday 3 weeks after your POWER28.</p>
					</div>
					<div class="col-10 col-sm-10 col-md-6 col-lg-6 col-xl-6 power_week_calendar_notes">
						<p class="calendar_notes_h"><img src="https://i.ibb.co/F5hBggr/slice53-3x.png" alt="slice53-3x" border="0" class="list_style_re"/> Repeat</p>
						<p class="calendar_notes_p">5 times, every 4 weeks.</p>
					</div>

				</div>
		<div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/example">
				   <a href="#"  class="Bottom_button_r">
				   <p>Can you give me an example?</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>
			</div>
		</div>
	</div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/PowerWeek.js